import { BYSTADIUM_ANALYTICS_SERVICES, SWAGMAGIC_ANALYTICS_SERVICES } from "@constants/analytics";
import { ANALYTICS_SHOP_TYPE } from "@constants/analytics/shop";


const STORE_DEPENDENT_MKT_PAGES = ["go/pricing", "go/catalog"];
const emptyObj = {};

export const getAnalyticsId = ({
  asPath,
  hostname,
  isStoreLoading,
  analytics = emptyObj,
  service,
  override = true,
}) => {
  const pathname = asPath ? asPath.split("?")[0] : "";
  const isStoreDependentPage = STORE_DEPENDENT_MKT_PAGES.some((page) => pathname.includes(page));
  const isDomainSwagmagic = hostname.includes("swagmagic");
  const defaultAnalyticsService = isDomainSwagmagic
    ? SWAGMAGIC_ANALYTICS_SERVICES[service]
    : BYSTADIUM_ANALYTICS_SERVICES[service];

  // below code is added to override for pages like book a call , launchpad , etc where it is not linked to any store
  if (pathname.startsWith("/go/") && !isStoreDependentPage) {
    return [defaultAnalyticsService];
  }

  if (isStoreLoading) return [];
  const isBystadiumDomain = hostname.includes("bystadium");

  const analyticsIdsToBeUsed = override
    ? [analytics[service]]
    : [analytics[service], defaultAnalyticsService];

  return analytics[service] && !isBystadiumDomain && !isDomainSwagmagic
    ? analyticsIdsToBeUsed
    : [defaultAnalyticsService];
};

export const getShopType = (store) => {
  if (store?.isKitShop) {
    return ANALYTICS_SHOP_TYPE.BUNDLE;
  }
  if (store?.isPricelessShop) {
    return ANALYTICS_SHOP_TYPE.PRICELESS;
  }
  if (store?.isLockerShop) {
    return ANALYTICS_SHOP_TYPE.LOCKER;
  }
  return ANALYTICS_SHOP_TYPE.SHOP;
};

export const getBaseEventLocationProperties = ({
  previewMode,
  isPricelessShop,
  isKitShop,
  number,
  isLockerShop,
}) => {
  return {
    mode: previewMode ? "preview" : "standard",
    shop_type: getShopType({ isPricelessShop, isKitShop, isLockerShop }),
    shop_number: number,
  };
};
